"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconButtonStyles = void 0;

var _styles = require("@material-ui/core/styles");

var withColor = function withColor(props, theme) {
  return props.color || theme.palette.text.primary;
};

var useIconButtonStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    buttonContainer: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid ".concat(theme.palette.divider),
      borderRadius: '50%'
    },
    pressed: {
      backgroundColor: theme.palette.action.active
    },
    withColor: {
      '& > span': {
        '& > span': {
          color: function color(props) {
            return withColor(props, theme);
          }
        },
        '& > svg': {
          fill: function fill(props) {
            return withColor(props, theme);
          }
        }
      }
    },
    small: {
      width: 36,
      height: 36,
      '& > span': {
        width: 24,
        height: 24,
        '& > svg': {
          width: 24,
          height: 24
        }
      }
    },
    medium: {
      width: 56,
      height: 56,
      '& > span': {
        width: 36,
        height: 36,
        '& > svg': {
          width: 36,
          height: 36
        }
      }
    },
    large: {
      width: 72,
      height: 72,
      '& > span': {
        width: 48,
        height: 48,
        '& > svg': {
          width: 48,
          height: 48
        }
      }
    }
  };
});
exports.useIconButtonStyles = useIconButtonStyles;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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